import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  Typography,
} from "@mui/material"
import { useEffect, useRef, useState } from "react"
import startedImgIcon from "../../images/service-started.png"
interface Props {
  otpGenrate: () => void;
  otpFill?: string;
  genRateLoading: boolean;
}

const GenRateotpCustomer = ({ otpGenrate, otpFill, genRateLoading }: Props) => {
  const [otp, setOtp] = useState(Array(6).fill(""));
  const inputRefs = useRef<HTMLInputElement[]>([]);

  // Fill OTP from API on mount / change
  useEffect(() => {
    if (otpFill) {
      setOtp(otpFill.split("").concat(Array(6 - otpFill.length).fill("")));
    } else {
      setOtp(Array(6).fill(""));
    }
  }, [otpFill]);

  const hasExistingOtp = !!otpFill;

  const handleButtonClick = () => {
    if (!hasExistingOtp) {
      otpGenrate();
    }
  };

  return (
    <Box>
      <Typography align="left" variant="h2" className="fw-medium font-24" mb={0}>
        {hasExistingOtp ? "Code Generated" : "Generate Code"}
      </Typography>

      <Box className="otp-box text-center d-flex justify-content-center align-items-center flex-column">
        <Box pb={3}>
          <FormControl className="d-flex justify-content-center gap-3 flex-row">
            {otp.map((digit, index) => (
              <input
                disabled
                key={index}
                ref={(el) => (inputRefs.current[index] = el!)}
                type="text"
                value={digit}
                style={{
                  maxWidth: "46px",
                  height: "56px",
                  textAlign: "center",
                  fontFamily: "Montserrat",
                  color: "#F475A4",
                  border: "1px solid #F475A4",
                  borderRadius: "6px",
                  fontSize: "20px",
                }}
                maxLength={1}
                inputMode="numeric"
              />
            ))}
          </FormControl>
        </Box>

        {hasExistingOtp ? (
          <Typography sx={{ fontSize: "14px", color: "#555", fontWeight: 500, mt: 1 }}>
            Please share this Code to end the service
          </Typography>
        ) : (
          <Button
            className="view-profile py-2 text-capitalize"
            onClick={handleButtonClick}
            disabled={genRateLoading}
            sx={{
              backgroundColor: genRateLoading ? "#e0e0e0" : "",
              color: genRateLoading ? "#9e9e9e" : "",
              "&:hover": { backgroundColor: genRateLoading ? "#e0e0e0" : "" },
            }}
          >
            {genRateLoading ? <CircularProgress style={{ color: "pink", fontSize: 20 }} size={20} /> : "Generate Code"}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default GenRateotpCustomer;

interface propsServiceStart {
  isloadingShow: boolean
  blankOtp: () => void
}

const ServiceStart = ({ isloadingShow, blankOtp }: propsServiceStart) => {
  useEffect(() => {
    blankOtp()
  }, [])
  return (
    <>
      <Typography
        align="left"
        variant="h2"
        className=" fw-medium font-24"
        mb={1}
      >
        Otp Generated{" "}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={7}>
          <Box
            className="otp-box h-100 text-center d-flex flex-column align-items-center justify-content-center"
            sx={{ mt: 1 }}
          >
            <Typography
              align="center"
              variant="body1"
              className="green-heading p-4"
              mb={2}
            >
              Your Service Has Started{" "}
            </Typography>
            <Typography align="center" variant="body1" className="" mb={2}>
              To Stop Your Service, Click Here{" "}
            </Typography>
            <Button className="view-profile py-2 text-capitalize">
              {isloadingShow ? (
                <Typography fontSize={1}>
                  <CircularProgress
                    style={{ color: "pink", fontSize: 20 }}
                    size={20}
                  />
                </Typography>
              ) : (
                "Stop Service"
              )}
            </Button>
          </Box>{" "}
        </Grid>
        <Grid item xs={12} lg={5} className="d-none d-xl-block m-auto">
          <Box
            sx={{
              maxWidth: 300,
              height: "auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={startedImgIcon}
              alt="Description"
              style={{ width: "100%", height: "auto" }}
            />
          </Box>{" "}
        </Grid>
      </Grid>
      <Box className="d-flex gap-1 justify-content-between "></Box>
    </>
  )
}

export { ServiceStart }
